import { events } from "@/mocks/content";

export function getEventBySlug(slug: string) {
  return events.find((e) => e.slug === slug);
}

export function getEventsByCategory(categoryId: string) {
  return events.filter((e) => e.categoryId === categoryId);
}

export function getRelatedEvents(slug: string, limit = 3) {
  const current = getEventBySlug(slug);
  if (!current) return events.slice(0, limit);
  const sameCategory = events.filter(
    (e) => e.slug !== slug && e.categoryId === current.categoryId,
  );
  const others = events.filter(
    (e) => e.slug !== slug && e.categoryId !== current.categoryId,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function getTopEvents(limit = 5) {
  return [...events].sort((a, b) => b.heat - a.heat).slice(0, limit);
}